var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"invoiced-invoiced-list",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'invoiced-order-list',"setLoading":_vm.setLoading,"gcPopupConfig":_vm.gcPopupConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }